<svg class="svg_icon--spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
  <defs>
    <style>
      .svg_icon--spinner .icon{fill:currentColor;}
      .svg_icon--spinner .circle {
        fill: none;
        stroke: currentColor;
        stroke-width: 16;
        stroke-opacity: 0.2;
      }
      .svg_icon--spinner .arc {
        fill: none;
        stroke: currentColor;
        stroke-width: 12;
        stroke-linecap: round;
        transform-origin: center;
        animation: spin 1s linear infinite;
      }
      @keyframes spin {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }
    </style>
  </defs>
  <title>Loading</title>
  <circle class="circle" cx="50" cy="50" r="40"/>
  <path class="arc icon" d="M50,10 A40,40 0 0,1 90,50" />
</svg>
